import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import {
  TonarRateConfigurationCreate,
  TonarRateConfigurationDetail,
  TonarRateConfigurationItem,
  TonarRateConfigurationUpdate,
} from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getTonarRateConfigurationList: builder.query<TonarRateConfigurationItem[], PayloadRequest>({
      query: (data) => ({
        url: `/v1/TonarRateConfiguration/${data.id}/configurations`,
      }),
      providesTags: ['TonarRateConfigurationList'],
    }),
    getTonarRateConfigurationDetail: builder.query<TonarRateConfigurationDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/TonarRateConfiguration/configurations/${data.id}/details`,
      }),
    }),
    changeTonarRateConfiguration: builder.mutation<void, TonarRateConfigurationUpdate>({
      query: (data) => ({
        url: `/v1/TonarRateConfiguration/configurations/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['TonarRateConfigurationList'],
    }),
    createTonarRateConfiguration: builder.mutation<void, TonarRateConfigurationCreate>({
      query: (data) => ({
        url: `/v1/TonarRateConfiguration/${data.nomenclatureId}/configurations`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TonarRateConfigurationList'],
    }),
    deleteTonarRateConfiguration: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/TonarRateConfiguration/configurations/${data.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TonarRateConfigurationList'],
    }),
  }),
});

export const {
  useChangeTonarRateConfigurationMutation,
  useCreateTonarRateConfigurationMutation,
  useGetTonarRateConfigurationDetailQuery,
  useLazyGetTonarRateConfigurationDetailQuery,
  useDeleteTonarRateConfigurationMutation,
  useGetTonarRateConfigurationListQuery,
} = request;
